 <template>
  <div>
    <p class="entry-title" @click="toggle()" :class="{expandable: this.hasDetails()}">
      <span>{{title()}}</span>
      <font-awesome-icon class="arrow" icon="chevron-down" v-if="!isExpanded && this.hasDetails()"/>
      <font-awesome-icon class="arrow" icon="chevron-up" v-if="isExpanded"/>
    </p>
    <div class="details" v-if="isExpanded">
      <div v-if="!!this.entry.details" class="entry-details" v-html="this.entry.details"></div>

      <div class="entry-details" v-for="(participant, x) in this.entry.participants" :key="x">
        <strong>{{participant.name}}</strong>
        <br/>
        <div v-html="participant.details"></div>
      </div>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'

export default {
  name: 'WhatsHappeningMeetingEntry',
  props: ['entry'],
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    title() {
      return this.participantNames().concat(this.entry.title).join(", ")
    },
    participantNames() {
      return _.map(this.entry.participants, (p) => { return p.name })
    },
    toggle: function(){
      if (!this.hasDetails()) { return }
      this.isExpanded = !this.isExpanded
    },
    hasDetails: function() {
      return !!this.entry.details || _.find(this.entry.participants, (p) => { return !!p.details })
    }
  }
}
</script>

<style lang="scss" scoped="">
.entry-details {
  ::v-deep a {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
